import { HTF_TIMEFRAMES } from "./tradingRuntimeConfig";

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:5000";
const SESSION_TOKEN_KEY = "spike_auth_token";

export const MAX_CHART_CANDLES = 3500;

export function normalizeHistoryCandles(candles) {
  return (candles || []).map((candle) => ({
    ...candle,
    isClosed: candle.isClosed !== false,
  }));
}

export function toClosedHistory(candles) {
  return normalizeHistoryCandles(candles).map((candle) => ({
    ...candle,
    isClosed: candle.isClosed !== false,
  }));
}

export function splitClosedAndActiveCandles(candles) {
  const normalizedCandles = normalizeHistoryCandles(candles);
  const lastCandle = normalizedCandles[normalizedCandles.length - 1] || null;

  if (lastCandle?.isClosed === false) {
    return {
      closedCandles: normalizedCandles.slice(0, -1),
      activeCandle: lastCandle,
    };
  }

  return {
    closedCandles: normalizedCandles,
    activeCandle: null,
  };
}

export function createHtfStreamState() {
  return HTF_TIMEFRAMES.reduce((state, htfTimeframe) => {
    state[htfTimeframe] = {
      closedCandles: [],
      activeCandle: null,
    };
    return state;
  }, {});
}

export async function fetchHistoryCandles({
  symbol,
  timeframe,
  signal,
  includeStructure = true,
}) {
  const token = window.localStorage.getItem(SESSION_TOKEN_KEY);
  const response = await fetch(
    `${API_BASE_URL}/history?symbol=${encodeURIComponent(
      symbol
    )}&timeframe=${timeframe}&includeStructure=${includeStructure ? 1 : 0}`,
    {
      signal,
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    }
  );

  if (!response.ok) {
    throw new Error(`History fetch failed for ${timeframe}: ${response.status}`);
  }

  const data = await response.json();
  const rawCandles = Array.isArray(data) ? data : data.candles || [];

  return normalizeHistoryCandles(rawCandles).slice(-MAX_CHART_CANDLES);
}

export function getUniqueHistoryTimeframes(timeframe) {
  return [...new Set([timeframe, ...HTF_TIMEFRAMES])];
}
